import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'font-(family-name:--font-gotham)',
    content: 'relative mt-16 overflow-hidden lg:mt-0 lg:pt-[93px]',
    bg: 'pointer-events-none absolute top-0 left-0 z-0 w-full object-top',
    footnotes:
      'relative z-1 my-10 flex max-w-246 flex-col px-3 text-[#A6A6A6] lg:my-20 lg:px-[49px]',
    footnote: 'text-[12px] leading-[1.36]',
    tabProducts: 'mb-12 lg:mb-20',
    navigation:
      'max-lg:scrollbar-hidden fixed right-0 bottom-2 left-0 z-10 mx-auto transition-transform duration-500 ease-out max-lg:overflow-x-scroll md:flex md:justify-center lg:top-[670px] lg:bottom-auto'
  },
  variants: {
    isScrolled: {
      true: {
        navigation: 'lg:translate-y-[calc(100vh-670px-70px)]'
      },
      false: {
        navigation: 'lg:translate-y-0'
      }
    },
    isNearFooter: {
      true: {
        navigation: 'pointer-events-none opacity-0'
      },
      false: {
        navigation: 'opacity-100'
      }
    }
  }
});
